import React, {useState} from 'react'
import { Button, Grid } from "@mui/material"
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function CenterButtonWithHeader(props) {

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={6} style={{ textAlign: "center", alignSelf: "flex-end" }}>
        <h1>{props.title}</h1>
        <hr />
        <Button size="large" variant="contained" color="primary" onClick={props.onClick}>{props.text}</Button>
      </Grid>
    </Grid>
  )
}


// takes in a title, and an array with button text and button onCLick func called buttons
// e.g. buttons=[{text: "Go", onClick: func1, variant:"!@#" (this is optional)}]
export function CenterButtonWithHeaderArray(props) {

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={6} style={{ textAlign: "center", alignSelf: "flex-end" }}>
        <h1>{props.title}</h1>
        <hr />
        {props.buttons.map(e =>
          <Button size="large" variant={e.variant ? e.variant : "contained"} color="primary" onClick={e.onClick} disabled={e.disabled}>{e.text}</Button>
        )}
      </Grid>
    </Grid>
  )
}

// center button with affidative
export function CenterButtonWithAffidative(props) {
  const [signed, setSigned] = useState(false) // starts quiz

  const handleCheckChange = event => {
        // console.log("event:" + event.target.name + " value:" + event.target.checked);
        setSigned(event.target.checked);
    }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
        <h1>{props.title}</h1>
        <hr />
      </Grid>
              <Grid item xs={12} md={12} style={{  alignSelf: "flex-end" }}>

        <p>{props.affidativeHeader}</p>
        <ol>
          {props.affidativeItems.map(e =>
            <li>{e}</li>
          )}
        </ol>
          <FormControlLabel control={<Checkbox  onChange={handleCheckChange}/>} label={props.affidativeSign} />
        </Grid>
              <Grid item xs={12} md={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>

        <Button disabled={!signed} size="large" variant="contained" color="primary" onClick={props.onClick}>{props.text}</Button>
      </Grid>
    </Grid>
  )
}